import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SystemMasterTabel from '../../Components/SystemMasterTabel/SystemMasterTabel';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
};

function FinalMaster() {
  const finishedType = 'finished-type';
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { finalList } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'finishes', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'finishes', 'delete');
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingFinal, setIsLoadingFinal] = useState(false);
  const [showFinal, setShowFinal] = useState(false);
  const [isFinalUnique, setIsFinalUnique] = useState(true);
  const [buttonDownFinal, setButtonDownFinal] = useState(true);
  const [finalBtnDisable, setFinalBtnDisable] = useState(false);
  const [addingFinal, setAddingFinal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isFinal, setIsFinal] = useState(false);
  const [finalData, setFinalData] = useState([]);
  const [isUniqFinalId, setIsUniqFinalId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');

  useEffect(() => {
    setFinalData(finalList);
    if (addingFinal) {
      setFinalData([
        ...finalList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [finalList, addingFinal]);

  const callApi = async () => {
    setButtonDownFinal(!buttonDownFinal);
    setIsLoadingFinal(true);
    buttonDownFinal ? setShowFinal(true) : setShowFinal(false);
    isEmpty(finalData) && (await dispatch(action.getFinalsDetails()));
    setIsLoadingFinal(false);
  };

  useEffect(() => {
    const array = [];
    finalData.forEach((ele, index) => {
      const n1 = ele?.name?.toString()?.trim()?.toLowerCase() || '';
      if (n1 === '') return;
      finalData.forEach((obj, places) => {
        if (index === places) return;
        const n2 = obj?.name?.toString()?.trim()?.toLowerCase() || '';
        if (n2 === '') return;
        if (n1 === n2) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsFinalUnique(true);
      setIsUniqFinalId([]);
    }
  }, [finalData]);

  const handleChnaged = (event, i) => {
    const finals = [...finalData];
    setIsFinalUnique(true);
    setIsUniqFinalId([]);
    const newValue = event?.target?.value;
    finals[i] = {
      ...finals[i],
      name: newValue,
      isEmpty: isEmpty(newValue?.toString()?.trim()),
    };
    const arr = [];
    const arrIndex = [];
    finals.forEach((ele, ind) => {
      const n1 = ele?.name?.toString()?.trim()?.toLowerCase() || '';
      if (n1 === '') return;
      finals.forEach((objs, index) => {
        if (ind === index) return;
        const n2 = objs?.name?.toString()?.trim()?.toLowerCase() || '';
        if (n2 === '') return;
        if (n1 === n2) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqFinalId([...newArr]);
    }
    setIsFinalUnique(isEmpty(arr));
    let isDisableFinal = false;
    finals.forEach((finalElement) => {
      if (isEmpty(finalElement?.name?.toString()?.trim())) {
        isDisableFinal = true;
      }
    });
    setFinalBtnDisable(isDisableFinal);
    setFinalData(finals);
  };

  const addFinal = async () => {
    if (!showFinal) {
      setAddingFinal(true);
      setButtonDownFinal(!buttonDownFinal);
      setIsLoadingFinal(true);
      buttonDownFinal ? setShowFinal(true) : setShowFinal(false);
      isEmpty(finalData) && (await dispatch(action.getFinalsDetails()));
      setIsLoadingFinal(false);
    } else if (!isEmpty(finalData)) {
      setFinalData([...finalData, tempObj]);
    } else {
      setFinalData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      finalData.splice(id, 1);
      let finalDel = false;
      finalData.forEach((finalElement) => {
        if (isEmpty(finalElement?.name?.trim())) {
          finalDel = true;
        }
      });
      setFinalBtnDisable(finalDel);
      setIsUniqFinalId([]);
      setIsFinalUnique(true);
      setFinalData([...finalData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveFinal = async () => {
    setIsFinal(true);
    if (!isEmpty(finalData)) {
      const emptyField = finalData.filter((britem) => britem.name === null || britem.name === '');

      if (isEmpty(emptyField)) {
        const data = finalData.map((brnobj) => {
          return {
            ...brnobj,
            name: brnobj?.name?.trim(),
          };
        });
        const finalSaveParams = {
          title: finishedType,
          names: JSON.stringify(data),
        };
        setAddingFinal(false);
        await dispatch(action.saveToSystemMaster(finalSaveParams, t));
        setAddingFinal(false);
        await dispatch(action.getFinalsDetails());
      } else {
        const newState = finalData.map((brobj) => (brobj?.isEmpty === false && brobj.name === null ? { ...brobj, isEmpty: true } : brobj));
        setFinalData(newState);
      }
    }
    setIsFinal(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const finalDeleteParams = {
      loggedInUserId,
      finishedTypeId: deleteId,
      title: finishedType,
    };
    await dispatch(action.deleteFromSystemMasters(finalDeleteParams, t));
    setFinalData([...finalList]);
    setIsLoadingConf(false);
    setShowConfirmation(false);
    await dispatch(action.getFinalsDetails());
  };

  const activeInactiveConfirmed = async () => {
    let final = {};
    setIsLoadingConf(true);
    finalData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          title: finishedType,
        };
        final = data;
      }
    });
    await dispatch(action.setActiveInactive(final, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setFinalData([...finalData]);
  };

  return (
    <>
      <SystemMasterTabel
        isLoading={isLoadingFinal}
        setShow={showFinal}
        callApi={callApi}
        buttonDown={buttonDownFinal}
        mainData={finalData}
        handleChanged={handleChnaged}
        addBtnClicked={addFinal}
        deletPressed={handleDelete}
        onSave={saveFinal}
        isDesabled={isFinal}
        title={t('FINAL_MASTER.TITLE')}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        inputName="finish"
        activeInactiveClicked={activeInactiveClicked}
        btnDisable={finalBtnDisable}
        isUnique={isFinalUnique}
        isUniqueId={isUniqFinalId}
      />
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={deleteConfirmed}
          title={t('FINAL_MASTER.DELETE_TITLE')}
          message={t('FINAL_MASTER.DELETE_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={activeInactiveConfirmed}
          title={t('FINAL_MASTER.ACTIVATE_DEACTIVATE_TITLE')}
          message={t('FINAL_MASTER.ACTIVATE_DEACTIVATE_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default FinalMaster;
